<template>
  <div>
    <h4>Primary</h4>
    <div class="d-flex gap-2 align-items-center mb-4">
      <McButton :disabled="disabled" :text="label" />
      <McButton :disabled="disabled" :text="label" :icon="icon" />
      <McButton :disabled="disabled" :text="label" :icon="icon" icon-position="right" />
      <McButton :disabled="disabled" :icon="icon" icon-position="right" />
      <McButton :disabled="disabled" :icon="icon" icon-position="right" text="" />

      <McButton :disabled="disabled" :text="label" size="sm" />
      <McButton :disabled="disabled" :text="label" size="sm" :icon="icon" />
      <McButton :disabled="disabled" :text="label" size="sm" :icon="icon" icon-position="right" />
      <McButton :disabled="disabled" size="sm" :icon="icon" icon-position="right" />
      <McButton :disabled="disabled" size="sm" :icon="icon" icon-position="right" text="" />
    </div>

    <h4>Split Button</h4>
    <div class="d-flex gap-2 align-items-center mb-4">
      <McButton
        :disabled="disabled"
        text="Aktifkan Automasi"
        icon="icon-fill_flash"
        split
        action-icon="icon-outline_setting"
      />
      <McButton
        :disabled="disabled"
        variant="secondary"
        text="Atur Jadwal"
        icon="icon-outline_calendar"
        split
      >
        <template #action-slot>
          <i class="mc-icon icon-outline_chevron-down" />
        </template>
      </McButton>
    </div>

    <h4>Secondary</h4>
    <div class="d-flex gap-2 align-items-center mb-4">
      <McButton :disabled="disabled" variant="secondary" :text="label" />
      <McButton :disabled="disabled" variant="secondary" :text="label" :icon="icon" />
      <McButton
        :disabled="disabled"
        variant="secondary"
        :text="label"
        :icon="icon"
        icon-position="right"
      />
      <McButton :disabled="disabled" variant="secondary" :icon="icon" icon-position="right" />
      <McButton
        :disabled="disabled"
        variant="secondary"
        :icon="icon"
        icon-position="right"
        text=""
      />

      <McButton :disabled="disabled" variant="secondary" :text="label" size="sm" />
      <McButton :disabled="disabled" variant="secondary" :text="label" size="sm" :icon="icon" />
      <McButton
        :disabled="disabled"
        variant="secondary"
        :text="label"
        size="sm"
        :icon="icon"
        icon-position="right"
      />
      <McButton
        :disabled="disabled"
        variant="secondary"
        size="sm"
        :icon="icon"
        icon-position="right"
      />
      <McButton
        :disabled="disabled"
        variant="secondary"
        size="sm"
        :icon="icon"
        icon-position="right"
        text=""
      />
    </div>

    <h4>Minimal</h4>
    <div class="d-flex gap-2 align-items-center mb-4">
      <McButton :disabled="disabled" variant="minimal" :text="label" />
      <McButton :disabled="disabled" variant="minimal" :text="label" :icon="icon" />
      <McButton
        :disabled="disabled"
        variant="minimal"
        :text="label"
        :icon="icon"
        icon-position="right"
      />
      <McButton :disabled="disabled" variant="minimal" :icon="icon" icon-position="right" />
      <McButton :disabled="disabled" variant="minimal" :icon="icon" icon-position="right" text="" />

      <McButton :disabled="disabled" variant="minimal" :text="label" size="sm" />
      <McButton :disabled="disabled" variant="minimal" :text="label" size="sm" :icon="icon" />
      <McButton
        :disabled="disabled"
        variant="minimal"
        :text="label"
        size="sm"
        :icon="icon"
        icon-position="right"
      />
      <McButton
        :disabled="disabled"
        variant="minimal"
        size="sm"
        :icon="icon"
        icon-position="right"
      />
      <McButton
        :disabled="disabled"
        variant="minimal"
        size="sm"
        :icon="icon"
        icon-position="right"
        text=""
      />
    </div>
  </div>
</template>

<script>
import McButton from '@/components/McButton'

export default {
  components: {
    McButton,
  },
  props: {
    label: {
      type: String,
    },
    icon: {
      type: String,
      default: 'icon-outline_download',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
